/**
 * =============================================================================
 * IDS CRM Web - milking schedule helpers
 * =============================================================================
 * One start time (and optional end time) per milking, driven by Milkings Per
 * Day. Times are 'HH:MM' 24-hour local strings, stored as two aligned JSONB
 * arrays on the farm site: milking_start_times and milking_end_times (entry N
 * is milking N's end, null when not recorded).
 */

/** Fit a times array to the chosen milkings-per-day count, keeping values. */
export function resizeMilkingTimes(times, count) {
  const current = Array.isArray(times) ? times : [];
  if (!count || count < 1) return [];
  return Array.from({ length: count }, (_, index) => current[index] || '');
}

/**
 * Payload form: what you see is what saves — only the milkings the current
 * Milkings Per Day count shows, and of those only the ones with a start time,
 * ends kept aligned to their start (null when blank). A milking with no start
 * is dropped whole so the two arrays can never drift out of step. Arrays
 * become null when empty.
 */
export function milkingSchedulePayload(data) {
  const count = parseInt(data.milkings_per_day, 10) || 0;
  const starts = resizeMilkingTimes(data.milking_start_times, count);
  const ends = resizeMilkingTimes(data.milking_end_times, count);
  const pairs = starts
    .map((start, index) => ({
      start: (start || '').trim(),
      end: (ends[index] || '').trim()
    }))
    .filter(pair => pair.start);
  if (!pairs.length) return { milking_start_times: null, milking_end_times: null };
  const endList = pairs.map(pair => pair.end || null);
  return {
    milking_start_times: pairs.map(pair => pair.start),
    milking_end_times: endList.some(Boolean) ? endList : null
  };
}

/** Display form: '06:00–08:00' when the end is recorded, '06:00' otherwise. */
export function formatMilkingTimes(startTimes, endTimes) {
  const starts = Array.isArray(startTimes) ? startTimes : [];
  const ends = Array.isArray(endTimes) ? endTimes : [];
  if (!starts.length) return null;
  return starts
    .map((start, index) => (ends[index] ? `${start}–${ends[index]}` : start))
    .join(', ');
}
